import { useContext } from "react";
import LayerOverviewTable from "./LayerOverviewTable";
import LoadingSpinner from "../../Loading/LoadingSpinner";
import { LayerAdminServiceContext } from "./LayerAdminServiceContext";

const LayerOverview = () => {
  const { overviews } = useContext(LayerAdminServiceContext)!;
  return (
    <>
      {overviews ? (
        <LayerOverviewTable overviews={overviews} />
      ) : (
        <LoadingSpinner />
      )}
    </>
  );
};

export default LayerOverview;
